import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/app/admin/components/AdminConsoleScreen.tsx");
